import { render, staticRenderFns } from "./importHistory.vue?vue&type=template&id=3aebf1e0";
import script from "./importHistory.vue?vue&type=script&lang=js";
export * from "./importHistory.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;